/**
 * The headless PDF print surface lives under `/print/*` and is loaded ONLY by the
 * backend's headless-Chrome worker (real users never navigate there). Several
 * modules branch on "am I on that route?" — skip the 401 -> /login redirect,
 * request downscaled images, skip service-worker registration. This is the single
 * home for that route-prefix predicate so those checks can't drift apart.
 *
 * Pass an explicit `pathname` from non-browser/test contexts; with no argument it
 * reads `window.location.pathname` when a DOM is present and is false otherwise.
 */
export const isHeadlessPrintRoute = (pathname?: string): boolean => {
  const path =
    pathname ??
    (typeof window !== 'undefined' ? window.location.pathname : undefined);
  return path?.startsWith('/print/') ?? false;
};
